import { withNamespace } from "@/i18n/lazy-route"

/** The devices slice (LLD §9.4, Task 2.2), loading the `devices` namespace with its chunks. */
const translations = {
  en: () => import("@/i18n/locales/en/devices.json"),
  fr: () => import("@/i18n/locales/fr/devices.json"),
}

export const DevicesScreen = withNamespace(
  "devices",
  () => import("./screens/DevicesScreen"),
  translations,
)
export const DeviceDetailScreen = withNamespace(
  "devices",
  () => import("./screens/DeviceDetailScreen"),
  translations,
)
